import useSWR from "swr";
import API from "../../../axios/instances/API";

const BASE_URL = "dashboard/analytics/organization-reports/overview/";

const fetcher = async (url) => {
  const { data } = await API.get(url);
  return data;
};

const useOrganizationReport = () => {
  const { data, error, mutate } = useSWR(BASE_URL, fetcher, {
    revalidateOnFocus: false,
  });

  return {
    data,
    isLoading: !error && !data,
    isError: error,
    mutate,
  };
};

export default useOrganizationReport;
